export default "__VITE_ASSET__Cj0V2rDZ__"